import { VisibilityOff, Visibility, Person } from "@mui/icons-material"
import { InputAdornment, IconButton } from "@mui/material"
import { JSX } from "react"

export const getVisibilityButton = (showConfirmPassword: boolean, action: () => void): JSX.Element => {
    return (
        <InputAdornment position="end">
            <IconButton onClick={action} tabIndex={-1}>
                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    );
};

export const emailAdornment: JSX.Element =(
    <InputAdornment position="start" sx={{ mr: 1.5 }}>
        <Person color="action" />
    </InputAdornment>
);